class ProductAnimationSection extends HTMLElement {
  /** @type {HTMLElement[]} */
  productItems = [];

  /** @type {HTMLElement[]} */
  mainImages = [];

  /** @type {number} */
  activeIndex = 0;

  /** @type {((event: Event) => void) | null} */
  _boundHandleScroll = null;

  connectedCallback() {
    this.productItems = Array.from(this.querySelectorAll('[data-product-item]'));
    this.mainImages = Array.from(this.querySelectorAll('[data-main-image]'));

    if (!this.productItems.length || !this.mainImages.length) return;

    this.productItems.forEach((item) => {
      item.addEventListener('mouseenter', this.handleActivate);
      item.addEventListener('focusin', this.handleActivate);
      item.addEventListener('click', this.handleActivate);
    });

    const defaultItem = this.productItems.find((item) => item.classList.contains('is-active')) || this.productItems[0];
    if (defaultItem) {
      this.setActiveByItem(defaultItem);
    }

    this.initScrollSwitch();
  }

  disconnectedCallback() {
    if (!this.productItems) return;

    this.productItems.forEach((item) => {
      item.removeEventListener('mouseenter', this.handleActivate);
      item.removeEventListener('focusin', this.handleActivate);
      item.removeEventListener('click', this.handleActivate);
    });

    this.destroyScrollSwitch();
  }

  /** @param {Event} event */
  handleActivate = (event) => {
    const targetItem = event.currentTarget;
    if (!(targetItem instanceof HTMLElement)) return;

    this.setActiveByItem(targetItem);
  };

  /** @param {HTMLElement} item */
  setActiveByItem(item) {
    const targetIndex = item.dataset.productIndex;
    if (!targetIndex) return;

    this.activeIndex = Number.parseInt(targetIndex, 10) || 0;

    this.productItems.forEach((productItem) => {
      productItem.classList.toggle('is-active', productItem.dataset.productIndex === targetIndex);
    });

    this.mainImages.forEach((image) => {
      image.classList.toggle('is-active', image.dataset.mainImage === targetIndex);
    });
  }

  initScrollSwitch() {
    if (this.productItems.length < 2) return;

    const handler = this.handleScroll.bind(this);
    this._boundHandleScroll = handler;
    window.addEventListener('scroll', handler, { passive: true });
    this.handleScroll();
  }

  destroyScrollSwitch() {
    if (this._boundHandleScroll) {
      window.removeEventListener('scroll', this._boundHandleScroll);
      this._boundHandleScroll = null;
    }
  }

  handleScroll() {
    const rect = this.getBoundingClientRect();
    const viewportHeight = window.innerHeight;
    const progress = Math.max(0, Math.min(1, (viewportHeight - rect.top) / (viewportHeight + rect.height)));
    const segmentSize = 1 / this.productItems.length;

    let nextIndex = Math.floor(progress / segmentSize);
    if (nextIndex >= this.productItems.length) {
      nextIndex = this.productItems.length - 1;
    }

    if (nextIndex === this.activeIndex) return;

    const nextItem = this.productItems[nextIndex];
    if (nextItem) {
      this.setActiveByItem(nextItem);
    }
  }
}

if (!customElements.get('product-animation-section')) {
  customElements.define('product-animation-section', ProductAnimationSection);
}
